import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isSegmentsListResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
});
